export const QueryKey = {
  GetFavoriteListings: 'FavoriteListings',
  GetListingEnriched: 'ListingEnriched',
  GetSavedSearches: 'SavedSearches',
  GetListingsForArea: 'ListingsForArea',
  GetUserFeeds: 'Feeds',
  GetFeedsMarket: 'FeedsMarket',
  GetClientListingFeedsSubscribedDefault: 'GetClientListingFeedsSubscribedDefault',
  GetFeedForZipCode: 'EphemeralFeed',
  GetFeed: 'Feed',
  GetPreferredAgent: 'PreferredAgent',
  GetZipCodeData: 'ZipCodeData',
  AiChat: 'AiChat',
  GetLoanBalance: 'LoanBalance',
  GetMarketInterest: 'Markets',
  GetMarketData: 'MarketData'
}
